import React from 'react';

import {
	getPostUpgradeModalToShowForUpgradeFreePoolTargetExperiment,
	Product,
	STORAGE_KEYS,
	type StorageAdapter,
	UpgradeModalComponent,
} from '../../utils';
import { ConfluenceAfterStandardUpgradeAIModal } from '../ConfluenceAfterStandardUpgradeAIModal';
import {
	CALENDAR_URL_STRING,
	ConfluenceAfterStandardUpgradeCalendarModal,
} from '../ConfluenceAfterStandardUpgradeCalendarModal';

export const ConfluenceUpgradeFreePoolExperimentModalPostUpgrade = ({
	storageAdapter,
	calendarUrl,
}: {
	calendarUrl?: string;
	storageAdapter: StorageAdapter;
}) => {
	const modalToShow = getPostUpgradeModalToShowForUpgradeFreePoolTargetExperiment(
		storageAdapter,
		Product.Confluence,
	);

	const cleanExperimentLocalStorageAttributes = () => {
		storageAdapter.removeItem(STORAGE_KEYS.Confluence.first);
		storageAdapter.removeItem(STORAGE_KEYS.Confluence.second);
	};

	switch (modalToShow) {
		case UpgradeModalComponent.ConfluenceAfterStandardUpgradeAIModal:
			return (
				<ConfluenceAfterStandardUpgradeAIModal
					onInteractionComplete={cleanExperimentLocalStorageAttributes}
				/>
			);
		case UpgradeModalComponent.ConfluenceAfterStandardUpgradeCalendarModal:
			return (
				<ConfluenceAfterStandardUpgradeCalendarModal
					calendarUrl={calendarUrl || CALENDAR_URL_STRING}
					onInteractionComplete={cleanExperimentLocalStorageAttributes}
				/>
			);
		case UpgradeModalComponent.None:
		default:
			return null;
	}
};
